module.exports = __webpack_public_path__ + "static/media/sales.52b31b97.png";